<script setup>
import store from '@/store'
import { defineProps, computed, ref, watch } from 'vue'
import { getDefaultKeyword } from '../js'
import { key } from 'localforage'
const props = defineProps({
 defaultKeywordShow: {
  type: Boolean,
  default: false
 },
})
const initFlag = ref(false)
const showDefaultKeyword = ref(false)
 watch(
  () => props.defaultKeywordShow,
  (newVal) => {
   
   if (newVal) {
     console.log('defaultKeywordShow',newVal)
    if(keywordList.value.length>0){
       showDefaultKeyword.value=true 
    }
    else if(initFlag.value==false)
     toGetKeywordList()
    else showDefaultKeyword.value=false
   }
   else  showDefaultKeyword.value=false 
  }
 )
 const storeCompany = computed(() => {
         if (store.getters.company)
            return store.getters.company
         else return {}
      })
 watch(() => storeCompany.value.companyId, (newVal) => {
     if(newVal){
        initFlag.value=false
        keywordList.value=[]
      
     }
 })
const keywordList = ref(
 []
)
const emits = defineEmits(['clickKeyword'])
const toClick = (item) => {

 emits('clickKeyword', item)
}
const toGetKeywordList=()=>{
    var companyId =store.getters.company.companyId
      // if(store.getters.company.companyId==32)
      // companyId=856
      getDefaultKeyword(companyId).then((res)=>{
        initFlag.value=true
          keywordList.value=res.data
          if(keywordList.value.length>0){
             showDefaultKeyword.value=true 
          }
          else showDefaultKeyword.value=false
      })
   
}
</script>
<template>
 <div class="defaultKeyword" v-if="showDefaultKeyword">
  <div class="text">默认搜索</div>
  <div class="keyword-content">
   <text v-for="(item,index) in keywordList" v-bind:key="index" class="keyword" @mousedown.prevent="toClick(item)">
    {{ item }}
   </text>
  </div>
 </div>
</template>
<style lang="less" scoped>
.defaultKeyword {
 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
 padding: 10px 10px 20px 10px;
 border-bottom-right-radius: 10px;
 border-bottom-left-radius: 10px;
 position: absolute;

 z-index: 999;
 background: white;
 width: 100%;

 .text {
  font-weight: bold;
 }

 .keyword-content {
  display: flex;
  flex-wrap: wrap;


  .keyword {
   line-height: normal;
   margin-top: 10px;
   margin-right: 10px;
   padding: 4px 11px;
   font-size: 13px;
   color: #00b2b9;
   background: #f8fefd;
  //    background: #e6f7f8;
  // /* 字体：主绿的深色版，对比度高，阅读清晰 */
  // color: #05a4c0;
//   color: rgb(15, 193, 203);          /* 文字颜色 */
// background-color: rgb(245, 248, 253); /* 背景颜色 */
   border-radius: 30px;
   max-width: 100px;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   cursor: pointer;

   &:hover {
    background: #f0fcfb;
    color: #008c91;
  //     background: #ccf0f2;
  // color: #017176;
// color: rgb(12, 154, 162);          /* 文字颜色加深（原色的 -10% 亮度） */
// background-color: rgb(230, 240, 250); /* 背景颜色变浅 */
   }
  }

 }
}
</style>